import { render } from "./AnexoDocumentoAcompanhamento.vue?vue&type=template&id=4e72ab20&scoped=true"
import script from "./AnexoDocumentoAcompanhamento.vue?vue&type=script&lang=js"
export * from "./AnexoDocumentoAcompanhamento.vue?vue&type=script&lang=js"

import "./AnexoDocumentoAcompanhamento.vue?vue&type=style&index=0&id=4e72ab20&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e72ab20"]])

export default __exports__